<div class="flex-header sis-app-header-label" style="font-weight:bold; font-size:20px;" translate>
    Filter
</div>

<div class="flex-content">
    <tyl-datepicker label="From Date" id="fromDate" style="padding-left:10px;" [(value)]="filterData.FromDate"
        (valueChange)="filterChange.emit();"></tyl-datepicker>
    <tyl-datepicker label="To Date" id="toDate" style="padding-left:10px;" [(value)]="filterData.ToDate"
        (valueChange)="filterChange.emit();"></tyl-datepicker>
</div>

<div class="filter-flex-footer">

    <!-- Left Buttons -->
    <tyl-button image="startover.png" label="Clear" (clickEvent)="clearFilter()"></tyl-button>

    <!-- Right Buttons -->
    <div class="footerRight">
        <tyl-button image="Cancel.png" label="Close" (clickEvent)="closeFilter()"></tyl-button>
    </div>
</div>